import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import { logout } from '../redux/authSlice'
import { useDispatch, useSelector } from 'react-redux'

const MasterLayout = ({ children }) => {
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation(); // Hook to get the current route
  const disPatch = useDispatch()


  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };
  const logOutFunct = () => {
    disPatch(logout())

  }

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
              ? "sidebar sidebar-open"
              : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type='button'
          className='sidebar-close-btn'
        >
          <Icon icon='radix-icons:cross-2' />
        </button>
        <div>
          <Link to='/dashboard' className='sidebar-logo'>
            <img
              src='assets/images/ilab-logo.png'
              alt='site logo'
              className='light-logo'
            />
            <img
              src='assets/images/ilab-logo.png'
              alt='site logo'
              className='dark-logo'
            />
            <img
              src='assets/images/ilab-logo.png'
              alt='site logo'
              className='logo-icon'
            />
          </Link>
        </div>
        <div className='sidebar-menu-area'>
          <ul className='sidebar-menu' id='sidebar-menu'>
            <li className='sidebar-menu-group-title'>
              <NavLink to='/dashboard'>
                <Icon
                  icon='solar:home-smile-angle-outline'
                  className='menu-icon'
                />
                Dashboard
              </NavLink>
            </li>

            <li className='dropdown'>
              <Link to='#'>
                <Icon icon="mdi:book-open-variant" className="menu-icon" />

                <span>Programs</span>
              </Link>
              <ul className='sidebar-submenu'>

                <li>
                  <NavLink
                    to='/category'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="mdi:tag-outline" className="menu-icon" />
                    Category
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to='/course'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="material-symbols:workspace-premium-outline" className="menu-icon" />
                    Courses
                  </NavLink>
                </li>

              </ul>
            </li>
            <li className="nav-list">
              <NavLink to="/location-master" className={(navData) => (navData.isActive ? "active-page" : "")}>
                <Icon icon="fluent:location-20-regular" className="menu-icon" />
                <span>Locations</span>
              </NavLink>
            </li>
            <li className="nav-list">
              <NavLink to="/about-us" className={(navData) => (navData.isActive ? "active-page" : "")}>
                <Icon icon="fluent:people-community-20-regular" className="menu-icon" />
                <span>Our Facilitators</span>
              </NavLink>
            </li>
            <li className="nav-list">
              <NavLink to="/management-team" className={(navData) => (navData.isActive ? "active-page" : "")}>
                <Icon icon="fa6-solid:user-tie" className="menu-icon" />
                <span> Management Team</span>
              </NavLink>
            </li>
            {/* <li className="nav-list">
              <NavLink to="/podcast" className={(navData) => (navData.isActive ? "active-page" : "")}>
                <Icon icon="fa6-solid:podcast" className="menu-icon" />
                <span> Podcast</span>
              </NavLink>
            </li> */}

            <li className='nav-list'>
              <NavLink
                to='/users-list'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon="solar:users-group-two-rounded-outline" className="menu-icon" />

                <span>User list</span>
              </NavLink>
            </li>

            <li className='nav-list'>
              <NavLink
                to='/review-management'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon="mdi:star-circle-outline" className="menu-icon" />
                <span>Review management</span>
              </NavLink>
            </li>

            <li className='nav-list'>
              <NavLink
                to='/payment-method'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon="mdi:cash-multiple" className="menu-icon" />
                <span>Payment Methods</span>
              </NavLink>
            </li>
            <li className='nav-list'>
              <NavLink
                to='/bokking-histroy'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon="mdi:cart-outline" className="menu-icon" />
                <span>Booking list</span>
              </NavLink>
            </li>

            <li className='nav-list'>
              <NavLink
                to='/certificate-approval'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon="mdi:certificate" className="menu-icon" />
                <span>Certificate Approval</span>
              </NavLink>
            </li>

            <li className='nav-list'>
              <NavLink
                to='/subscriber'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon="mdi:email-newsletter" className="menu-icon" />
                <span>Subscribers</span>
              </NavLink>
            </li>
            <li className='nav-list'>
              <NavLink
                to='/contact-us-list'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon="mdi:chat-outline" className="menu-icon" />

                <span>Contact us list</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div className='navbar-header'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-4'>
                <button
                  type='button'
                  className='sidebar-toggle'
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon='iconoir:arrow-right'
                      className='icon text-2xl non-active'
                    />
                  ) : (
                    <Icon
                      icon='heroicons:bars-3-solid'
                      className='icon text-2xl non-active '
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type='button'
                  className='sidebar-mobile-toggle'
                >
                  <Icon icon='heroicons:bars-3-solid' className='icon' />
                </button>

              </div>
            </div>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-3'>
                {/* ThemeToggleButton */}
                <ThemeToggleButton />

                {/* Notification dropdown end */}
                <div className='dropdown'>
                  <button
                    className='d-flex justify-content-center align-items-center rounded-circle'
                    type='button'
                    data-bs-toggle='dropdown'
                  >
                    <img
                      src='assets/images/admin_profile.png'
                      alt='image_user'
                      className='w-40-px h-40-px object-fit-cover rounded-circle'
                    />
                  </button>
                  <div className='dropdown-menu to-top dropdown-menu-sm'>
                    <div className='py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                      <div>
                        <h6 className='text-lg text-primary-light fw-semibold mb-2'>
                          iLap
                        </h6>
                        <span className='text-secondary-light fw-medium text-sm'>
                          Admin
                        </span>
                      </div>
                      <button type='button' className='hover-text-danger'>
                        <Icon
                          icon='radix-icons:cross-1'
                          className='icon text-xl'
                        />
                      </button>
                    </div>
                    <ul className='to-top-list'>
                      {/* <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'
                          to='/view-profile'
                        >
                          <Icon
                            icon='solar:user-linear'
                            className='icon text-xl'
                          />{" "}
                          My Profile
                        </Link>
                      </li> */}
                      {/* <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'
                          to='/email'
                        >
                          <Icon
                            icon='tabler:message-check'
                            className='icon text-xl'
                          />{" "}
                          Inbox
                        </Link>
                      </li> */}
                      {/* <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'
                          to='/company'
                        >
                          <Icon
                            icon='icon-park-outline:setting-two'
                            className='icon text-xl'
                          />
                          Setting
                        </Link>
                      </li> */}
                      <li onClick={logOutFunct}>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3'
                          to='#'

                        >
                          <Icon icon='lucide:power' className='icon text-xl' />{" "}
                          Log Out
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className='dashboard-main-body'>{children}</div>

        {/* Footer section */}
        <footer className='d-footer'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <p className='mb-0'>© 2025 iLap. All Rights Reserved.</p>
            </div>
            <div className='col-auto'>
              <p className='mb-0'>
                Developed & Maintained By <span className='text-primary-600'>Ocean Softwares</span>
              </p>
            </div>
          </div>
        </footer>
      </main>
    </section>
  );
};

export default MasterLayout;
